import http from "../core/http";
const group = 'teeIssues';

export const getDataListRequest =  async (data) => {
    return await http.post(`${group}/get`, data).then(res => res.data).catch(http.defaultCatch);
}

export const isDisplayedRequest =  async (data) => {
    return await http.post(`${group}/isDisplayed`, data).then(res => res.data).catch(http.defaultCatch);
}

export const createDataRequest =  async (data) => {
    return await http.post(`${group}/create`, data).then(res => res.data).catch(http.defaultCatch);
}

export const updateDataRequest =  async (data) => {
    return await http.post(`${group}/update`, data).then(res => res.data).catch(http.defaultCatch);
}

export const deleteDataRequest =  async (data) => {
    return await http.post(`${group}/delete`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getTeeListRequest =  async (data) => {
	return await http.post(`${group}/getTeeList`, data).then(res => res.data).catch(http.defaultCatch);
}

export const findTeeByBarcodeRequest =  async (data) => {
	return await http.post(`${group}/findTeeByBarcode`, data).then(res => res.data).catch(http.defaultCatch);
}
